export enum EditTransactionRuleStep {
  EditGeneralSettings = 0,
  EditTransactionSelectors = 1,
  EditTransactionModifiers = 2,
  EditResponseVisualization = 3,
}
